import { syncStacktrace } from 'auto-trace';
import { EMPTY } from 'rxjs';
import { infoToast } from 'toast-service!sofe';

export function checkForFailedFetch(err) {
  if (
    err
      .toString()
      .toLowerCase()
      .indexOf('failed to fetch') !== -1
  ) {
    infoToast('Network connection error. Please refresh the page and try again.');
    return EMPTY;
  }
  if (err.status == 403) {
    return EMPTY;
  } else throw syncStacktrace(err);
}
